import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const PATH = "/";

const DashboardPage = lazyWithRetry(() => import("@/features/dashboard/pages/DashboardPage"));

const dashboardRoutes: RouteConfig[] = [
  {
    path: PATH,
    element: <DashboardPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default dashboardRoutes;
